module.exports = __webpack_public_path__ + "static/img/rankboardClick.4af5709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/rankboardClick.png
// module id = JKuJ
// module chunks = 1